import $ from 'jquery';
import videojs from 'video.js';
import "video.js/dist/video-js.css";


const videoJs = (() => {

  const defaultVideoJs = () => {
    var homeSearchVideo = document.getElementById('search-video');
    if(homeSearchVideo){
      homeSearchVideo.play();
    }
  };


  const init = () => {
    defaultVideoJs();
  };

  return {
    init,
  };
})();

export default videoJs;
